export class WbForm {
  constructor() {
    this.datas = {
      messages: {
        errorBannerMessage: document.querySelector('.freeform-form')
          ? document.querySelector('.freeform-form').getAttribute('data-form-error-message')
          : '',
        successBannerMessage: document.querySelector('.freeform-form')
          ? document.querySelector('.freeform-form').getAttribute('data-form-success-message')
          : '',
      },
    };
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;
    const inputElementList = document?.querySelectorAll('.field__input');
    const selectElementList = document?.querySelectorAll('.field__group > select');

    selectElementList?.forEach(select => {
      select.closest('.field__group')?.classList.add('field__group--select');
      if (select?.value !== '' || select?.selectedIndex >= 0) {
        select.previousElementSibling?.classList.add('--active');
      }
    });

    inputElementList?.forEach(input => {
      if (input?.value !== '') {
        input.previousElementSibling?.classList.add('--active');
      }
    });

    document.querySelector('body')._addCustomEventListener('focusin', '.field__input', _this.inputFocusIn.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('focusout', '.field__input', _this.inputFocusOut.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('change', '.sujetContactMRC select', _this.openSubjectTab.bind(_this));

    this.overrideAjaxMessages();
    this.addFileLabelClass();

    document.querySelectorAll('.fui-input[type="file"]')?.forEach(input => {
      input.addEventListener('change', function() {
        let closest = input.closest('div');
        if (input.value) {
          let files = input.files;
          let filesNames = '';

          for (var i = 0; i < files.length; i++) {
            filesNames += files[i].name + '<br/>';
          }
          input.setAttribute('data-title', input.value.replace(/^.*[\\\/]/, ''));
          closest.querySelector('.val').innerHTML = filesNames;
        } else {
          input.setAttribute('data-title', input.getAttribute('no-file'));
          closest.querySelector('.val').innerHTML = '';
        }
      });
    });

    this.beforeFormieSubmit();
  }

  beforeFormieSubmit(e) {
    const $babillard = document.querySelector('.formBabillardDesc');
    if ($babillard) {
      const $form = document.querySelector('.formBabillardDesc').closest('form');
      $form.addEventListener('onBeforeFormieSubmit', el => {
        const textElement = document.querySelector('.formBabillardDesc textarea.fui-input');
        const textContent = textElement.value;
        let transformContent = '';
        transformContent = textContent.replace(/font-weight: bold;/g, ' babillardDesc-bold ');
        transformContent = transformContent.replace(/font-style: italic;/g, ' babillardDesc-italic ');
        transformContent = transformContent.replace(/text-decoration-line: underline;/g, ' babillardDesc-underline ');

        transformContent = transformContent.replace(
          /<span style="([^>]*)babillardDesc-bold([^>]*)">(.*?)<\/span>/g,
          '<span style="$1 $2"><strong>$3</strong></span>',
        );
        transformContent = transformContent.replace(
          /<span style="([^>]*)babillardDesc-italic([^>]*)">(.*?)<\/span>/g,
          '<span style="$1 $2"><i>$3</i></span>',
        );

        transformContent = transformContent.replace(
          /<span style="([^>]*)babillardDesc-underline([^>]*)">(.*?)<\/span>/g,
          '<span style="$1 $2"><u>$3</u></span>',
        );

        transformContent = transformContent.replace(/<span ([^>]*)>(.*?)<\/span>/g, '$2');
        textElement.innerHTML = transformContent;
      });
    }
  }

  inputFocusIn(e) {
    const ele = e.targetElement;
    ele.previousElementSibling?.classList.add('--active');
  }

  inputFocusOut(e) {
    const ele = e.targetElement;

    if (!ele.value.length) {
      ele.previousElementSibling?.classList.remove('--active');
    }
  }

  openSubjectTab(e) {
    const ele = e.targetElement;
    const choice = ele.value;
    console.log(choice);
    switch (choice) {
      case 'Collectes et matières résiduelles':
        document.querySelector('.submitContactMRC').style.display = 'none';
        window.open('https://info-collectes.ca/nous-joindre/', '_blank').focus();
        break;
      case 'Service de vidange des installations septiques':
        document.querySelector('.submitContactMRC').style.display = 'none';

        window
          .open(
            'https://info-collectes.ca/vidange-obligatoire-des-installations-septiques/#pour-nous-joindre',
            '_blank',
          )
          .focus();

        break;
      case 'Demande d’accès à l’information et renseignements personnels':
        document.querySelector('.submitContactMRC').style.display = 'none';
        window.open('https://roussillon.ca/la-mrc/acces-a-linformation-et-renseignements-personnels', '_blank').focus();
        break;
      default:
        // code block
        document.querySelector('.submitContactMRC').style.display = 'block';
    }
  }

  addFileLabelClass() {
    document.querySelectorAll('.fui-input[type="file"]')?.forEach(input => {
      input.closest('div').classList.add('field__label--file');
      let closest = input.closest('div');
      let inputBtn = document.createElement('div');
      inputBtn.innerHTML =
        '<span class="fui-btn wb-button wb-button--primary choose-file">' + input.getAttribute('no-file') + '</span>';

      let inputInfo = document.createElement('div');
      inputInfo.setAttribute('class', 'val');
      closest.insertBefore(inputBtn, closest.firstChild);
      closest.insertBefore(inputInfo, closest.firstChild);

      inputBtn.addEventListener('click', function() {
        input.click();
      });
    });
  }

  overrideAjaxMessages() {
    const datas = this.datas;
    document.addEventListener('freeform-ready', function(event) {
      // Set AJAX validation to true by default
      event.options.ajax = true;
      for (const [data, messages] of Object.entries(datas)) {
        event.options.errorBannerMessage = messages.errorBannerMessage;
        event.options.successBannerMessage = messages.successBannerMessage;
      }
    });
  }
}
